import * as angular from "angular";
import { IAccountUserMapping } from "@interfaces/IUser";
import "./userPermissions.scss";

class UserPermissionsComponentController implements angular.IComponentController {
    userMapping: IAccountUserMapping;
    accountId: number;

    constructor() {

    }
    $onInit(): void {}

    $onChanges(): void {}

}

export class UserPermissionsComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            userMapping: "<",
            accountId: "<?"
        };

        this.controller = UserPermissionsComponentController;
        this.template = require(`./userPermissions.html`);
    }
}
